import React, { createContext } from 'react';
import { useDecide } from '@bombas/react/util';
export var ApplicationContext = createContext({});
/**
 * General Application Context
 *
 * @remarks
 *
 * This is a general application context that should be used to store, share,
 * and update information needed in many areas of the application.
 */
var ApplicationProvider = function (_a) {
    var _b = _a.queryParams, queryParams = _b === void 0 ? {} : _b, qbsDiscountData = _a.qbsDiscountData, productCardsConfig = _a.productCardsConfig, children = _a.children;
    var pcpSavingsCopyVariation = useDecide('pcp_savings_copy');
    var context = {
        queryParams: queryParams,
        qbsDiscountData: qbsDiscountData || {},
        productCardsConfig: productCardsConfig,
        testVariations: {
            pcp_savings_copy: pcpSavingsCopyVariation
        }
    };
    return (React.createElement(ApplicationContext.Provider, { value: context }, children));
};
export default ApplicationProvider;
